import React from 'react';
import Border from '../common/border';
// import ActivityTitle from '../common/ActivityTitle';
import GreatForTags from '@/components/stay-experience/GreatForTags';
import { TravellerType } from '@/types/activityDetailsTypes';

interface TargetAudienceProps {
  types: TravellerType[];
}

const TargetAudience: React.FC<TargetAudienceProps> = ({ types }) => {
  // Convert TravellerType objects to string tags
  const tags = types
    .map(type => {
      if (typeof type === 'string') return type;
      return (type as { title?: string })?.title || '';
    })
    .filter(Boolean);

  if (tags.length === 0) return null;

  return (
    <div>
      {/* <ActivityTitle title='Great for' className='' /> */}
      <GreatForTags tags={tags} showLabel={true} />
      <Border />
    </div>
  );
};

export default TargetAudience;
